import { useChartConnect } from '@chartapi/react-connect'
import { useEffect, useState } from 'react'
import { apiURL } from '../../../utilities/URLs'
import { company, customerData } from '../../../utilities/CustomerData'

import chartLogo from '../../../assets/chartLogo.png'

export function DashboardChartInstantCalculation({ setIsChartInstantCalc, setCheckForCalculation }) {
  const onSuccess = ({ code }) => setCode(code)
  const onError = ({ errorMessage }) => setShowError(true)
  const onClose = () => console.log('User exited Chart Connect')

  const { open } = useChartConnect({
    clientId: process.env.REACT_APP_CHART_CLIENT_ID,
    flow: 'full-irs-online-account',
    zIndex: 999,
    sandbox: false,
    onSuccess,
    onError,
    onClose
  })
  const [code, setCode] = useState('')
  const [sendingChartCode, setSendingChartCode] = useState(false)
  const [showError, setShowError] = useState(false)
  const [showPopup, setShowPopup] = useState(false)


  useEffect(() => {
    const handleUploadChartCode = async () => {
      setSendingChartCode(true)

      const chartAccessTokenResponse = await fetch(`${apiURL}/api/uploadChartCode?contactId=${encodeURIComponent(customerData.customerLeadData.leadContact.contactId)}&code=${encodeURIComponent(code)}&isAuth=${encodeURIComponent(0)}&isReconnect=${encodeURIComponent(0)}&isSwitch=${encodeURIComponent(0)}`)
      const chartAccessTokenData = await chartAccessTokenResponse.json()
      setSendingChartCode(false)

      if (chartAccessTokenData.response.error) {
        console.error(chartAccessTokenData.response.error)
        setShowError(true)
      } else {
        customerData.customerLeadData.leadContact.chartInstantAccessToken = '1'
        setShowPopup(true)
        setCheckForCalculation(true)
      }
    }

    if (code)
      handleUploadChartCode()
  }, [code])

  useEffect(() => {
    if (showError) {
      setTimeout(() => {
        setShowError(false)
      }, 5000)
    }
  }, [showError])

  return (
    <div className='lg:w-full w-11/12 flex flex-col gap-4'>
      <div className='shadow-full rounded-xl p-6 w-full h-fit flex flex-col bg-[#5186C0] font-mont text-white'>
        <div className='w-full flex flex-col items-center'>
          <div className='w-full flex flex-col items-center gap-8'>
            <button 
              disabled={sendingChartCode} 
              onClick={() => open()} 
              className={`w-full p-4 rounded-full text-3xl font-bold shadow-md flex flex-col items-center text-white ${sendingChartCode ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#FF8C00] hover:bg-[#E67E00] transition duration-200'}`}>
              <div className='flex flex-col items-center gap-2'>
                <p className='text-xl'>Complete Your Calculation</p>
                <p className='text-lg'>Click Here</p>
              </div>
            </button>
            <div className='flex flex-col items-center gap-4 bg-white p-4 rounded-md shadow-md w-full'>
              <p className='text-sm text-center text-black'>See QUICK Video Below For Instructions on NEXT STEPS!</p>
              <iframe className='w-full aspect-video' src="https://www.loom.com/embed/7b3fa2cc8f0a408c879c10c061d409c8?sid=3d1f361d-46e2-4c8f-8e68-433d0d6b2f4e&hideEmbedTopBar=true" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            {sendingChartCode && (
              <div className='flex flex-row items-center justify-center gap-2 -mb-5'>
                <div className='loader ease-linear rounded-full border-[6px] border-t-[6px]  h-8 w-8 mt-4 mb-4'></div>
                <p>Grabbing IRS Data, Please Wait...</p>
              </div>
            )}
            {showError && (
              <p>Oops! We ran into an issue while trying to log in to your IRS account. Please try again in about 10 minutes. Thanks for your patience! <span className='font-bold'>Please note that your application is still in process.</span></p>
            )}
          </div>
        </div>
        {showPopup && (
          <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50'>
            <div className='bg-white p-6 rounded-lg shadow-lg text-center'>
              <p className='font-bold text-lg text-black'>Calculation is underway</p>
              <p className='text-black'>Your refund amount is being calculated. This process may require up to 15 minutes. Thank you for waiting.</p>
              <button onClick={() => setIsChartInstantCalc(false)} className='mt-4 px-4 py-2 bg-primaryColor text-white rounded-lg hover:bg-primaryDarkColor transition duration-200'>
                OK
              </button>
            </div>
          </div>
        )}
      </div>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-4'>
        <p className='font-bold text-2xl text-[#646464]'>What Do I Do Next?</p>
        <p className='font-bold text-xl text-[#646464]'>Click <span onClick={() => open()} className='text-[#FF8C00] underline cursor-pointer'>HERE</span> to get your instant calculation now.</p>
        <div className='flex flex-row items-center gap-4'>
          <img className= 'w-14 h-14' src={chartLogo} />
          <p className='font-bold text-lg text-[#646464]'>{company.companyName} uses Chart to access your tax records.</p>
        </div>
      </div>
    </div>
  )
}